export const galleryImages = [
  // Politics - 9 images
  {
    id: 'pol-1',
    category: 'politics',
    url: 'https://customer-assets.emergentagent.com/job_fcfd83c0-6b27-4072-9cb8-321986851645/artifacts/kvg1ve4v_jussi_nukari_KUJ2.avif',
    title: 'Politics',
  },
  {
    id: 'pol-2',
    category: 'politics',
    url: 'https://customer-assets.emergentagent.com/job_fcfd83c0-6b27-4072-9cb8-321986851645/artifacts/5fjusb9h_JussiNukari-SauliNiinisto%CC%88.avif',
    title: 'Sauli Niinistö',
  },
  {
    id: 'pol-3',
    category: 'politics',
    url: 'https://customer-assets.emergentagent.com/job_fcfd83c0-6b27-4072-9cb8-321986851645/artifacts/qkta5k2d_Nukari-kuukauden-kuva.avif',
    title: 'Month Photo',
  },
  {
    id: 'pol-4',
    category: 'politics',
    url: 'https://customer-assets.emergentagent.com/job_fcfd83c0-6b27-4072-9cb8-321986851645/artifacts/x5d3ali8_Paavova%CC%88yrynen.avif',
    title: 'Paavo Väyrynen',
  },
  {
    id: 'pol-5',
    category: 'politics',
    url: 'https://customer-assets.emergentagent.com/job_fcfd83c0-6b27-4072-9cb8-321986851645/artifacts/tbpv0ehg_Putin.avif',
    title: 'Putin',
  },
  {
    id: 'pol-6',
    category: 'politics',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/nxk28d04_7f1dff_2af647e4fab64d7cac7c0bb404e33624~mv2.avif',
    title: 'Politics',
  },
  {
    id: 'pol-7',
    category: 'politics',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/5qnhfr4i_7f1dff_fe7ee9d7dbe44915a8c91cdf104b7662~mv2.avif',
    title: 'Politics',
  },
  {
    id: 'pol-8',
    category: 'politics',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/qr4y9el0_116388290.avif',
    title: 'Politics',
  },
  {
    id: 'pol-9',
    category: 'politics',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/4rn78n90_trumpjaputin.avif',
    title: 'Trump and Putin',
  },
  
  // Sports - 6 images
  {
    id: 'sport-1',
    category: 'sports',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/sc48pjkc_112395673.avif',
    title: 'Sports',
  },
  {
    id: 'sport-2',
    category: 'sports',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/bh5xp03t_125831603.avif',
    title: 'Sports',
  },
  {
    id: 'sport-3',
    category: 'sports',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/mxlt22yo_jnu____-142946-DSC_3126.avif',
    title: 'Sports',
  },
  {
    id: 'sport-4',
    category: 'sports',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/rm9q0dzu_JussiNukariGlenKamara.avif',
    title: 'Glen Kamara',
  },
  {
    id: 'sport-5',
    category: 'sports',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/ngk46gu9_vuoden%20syka%CC%88hdytta%CC%88vin%20urheilukuva.avif',
    title: 'Sports Photo of the Year',
  },
  {
    id: 'sport-6',
    category: 'sports',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/xct6i09i_630351.avif',
    title: 'Sports',
  },
  
  // Nature - 12 images
  {
    id: 'nature-1',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/b1vtqp2v_7f1dff_e4550515c9e34fc09162ea2acad2ca10~mv2.avif',
    title: 'Nature',
  },
  {
    id: 'nature-2',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/t8zrvptg_Jussinukarisusi2.avif',
    title: 'Wolf',
  },
  {
    id: 'nature-3',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/zictwpm8_Jussunukarikarhu_edited.avif',
    title: 'Bear',
  },
  {
    id: 'nature-4',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/sq6oky05_Nukari%20Lehtikuva%20saimaannorppa-1.avif',
    title: 'Saimaa Ringed Seal',
  },
  {
    id: 'nature-5',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/fvvwq4xn_7f1dff_3a05150fe22546749067c14b2f43f5f7~mv2.avif',
    title: 'Nature',
  },
  {
    id: 'nature-6',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/83uby8hb_7f1dff_5d84929cd5594b07a670364f22e78946~mv2.avif',
    title: 'Nature',
  },
  {
    id: 'nature-7',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/zd2lrs5n_7f1dff_476cd3d6d2a64039a04e185f1cbbb6da~mv2.avif',
    title: 'Nature',
  },
  {
    id: 'nature-8',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/k8w778qg_7f1dff_4336696908cf42b89d58c3efc8470538~mv2.avif',
    title: 'Nature',
  },
  {
    id: 'nature-9',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/2nmt8ol6_7f1dff_bbfc2628bbdc484d8ba989cc0fdd689f~mv2.avif',
    title: 'Nature',
  },
  {
    id: 'nature-10',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/tkbiopgq_7f1dff_c9244d4c4b4b4e9682fc6fa388d70a76~mv2.avif',
    title: 'Nature',
  },
  {
    id: 'nature-11',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/ne6h3i6m_7f1dff_d31c3c2040034cbf9b20ec4b3e29feaf~mv2.avif',
    title: 'Nature',
  },
  {
    id: 'nature-12',
    category: 'nature',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/gg1zabhi_7f1dff_eb45f2ad0550436697322f23d64428bd~mv2.avif',
    title: 'Nature',
  },
  
  // People - 5 images
  {
    id: 'people-1',
    category: 'people',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/vxfin8m3_jussi_nukari_HEN1.avif',
    title: 'People',
  },
  {
    id: 'people-2',
    category: 'people',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/9prb542b_jussi_nukari_KUJ1.avif',
    title: 'People',
  },
  {
    id: 'people-3',
    category: 'people',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/amynuh58_jussinu-020159_JNU2718.avif',
    title: 'People',
  },
  {
    id: 'people-4',
    category: 'people',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/2mitvcqw_jussinu-110840_JNU3134.avif',
    title: 'People',
  },
  {
    id: 'people-5',
    category: 'people',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/isuf0ara_jussinu-124353_JNU9040.avif',
    title: 'People',
  },
  
  // Foreign Countries - 12 images
  {
    id: 'foreign-1',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/m8k7dd3n_7f1dff_2c8054128d3a4c39a9766bba6e3c3808~mv2.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-2',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/4p4c2m21_7f1dff_71ef97e34e684b2789961703d49bbda6~mv2.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-3',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/qkmdd3b2_7f1dff_86e5859f565a4dc28decb3c2e6af9224~mv2.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-4',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/prkn0zj4_7f1dff_983c726348e94443bb5ec59ec61bf49b~mv2.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-5',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/058swzl1_7f1dff_5733e653d87d45f3814df3e73b04b5fc~mv2.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-6',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/yjxn9a2f_123753281.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-7',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/235kqgsc_123792818.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-8',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/04wk2j8b_jussi_nukari_KUJ3.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-9',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/7p3uf9km_jussi_nukari_KUJ7.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-10',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/yeie9c13_jussinu-094704_JNU5254.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-11',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/sta1mbt7_7f1dff_bec4b9c24dbc4c0096715d3ef32975ab~mv2.avif',
    title: 'Foreign Countries',
  },
  {
    id: 'foreign-12',
    category: 'foreignCountries',
    url: 'https://customer-assets.emergentagent.com/job_nukari-photography/artifacts/lnb8ab47_7f1dff_e77cd537cb404eef8ad232060b4372d0~mv2.avif',
    title: 'Foreign Countries',
  },
];